import React from 'react';

const VrGoggleSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1334 866.5"
    className="vr-btn"
    style={{ fill: props.fill }}
  >
    <path d="M0,740.2v-614c1.2-7.4,1.9-14.9,3.6-22.1C18.7,41,70.9,0,136.1,0H1197.9a156.615,156.615,0,0,1,19.4,1.1c53.1,6.5,97.8,45.1,111.5,96.7,2.5,9.3,3.5,18.9,5.2,28.4v614c-.4,2.9-.8,5.9-1.2,8.8-9,67.8-63.9,117.1-132,117.3q-163.5.45-326.9.1c-30.9,0-54.1-17-64-46.3q-18.45-54.75-37-109.6c-6.1-18.1-11.4-36.5-18.9-54.1-16.8-39.5-57.8-62-100.7-55.4-37.5,5.8-63.7,26.7-76.3,62.8-17.8,51.2-34.8,102.6-52.1,153.9-10.9,32.3-33.4,48.6-67.4,48.6H136.1a156.66,156.66,0,0,1-19.4-1.2A131.879,131.879,0,0,1,5,767.5C2.7,758.7,1.6,749.4,0,740.2ZM1033.6,600a166.465,166.465,0,0,0,166.6-166.8c-.1-92.1-74.1-166.6-166.3-166.6A166.3,166.3,0,0,0,867,436.6C868.7,525.6,940.5,599.4,1033.6,600Zm-733.8,0c91.3-.2,164.8-71.4,167-161.3,2.4-95.8-70.5-171.1-165.7-172-93.2-.9-166.5,74.4-167.4,164.9C132.8,524,206.2,598.7,299.8,600Z" />
  </svg>
);

export default VrGoggleSvg;
